import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';

import { authApi } from 'src/api';

import { clearProfileState, getProfile } from '../profile';
import { setAuthErrors } from './auth.slice';

import { ROUTE } from 'src/constants';
import { normalizeErrorResponse } from 'src/utils';

export const createUser = createAsyncThunk('auth/create-user', async (data, thunkApi) => {
  try {
    const { payload, navigate } = data;

    const response = await authApi.createUser(payload);

    navigate(ROUTE.AUTH.SIGN_IN);

    toast(response?.message, { type: 'success', position: 'top-right' });

    return response;
  } catch (error) {
    const { response } = error;

    thunkApi.dispatch(setAuthErrors(normalizeErrorResponse(response?.data?.errors)));
  }
});

export const loginUser = createAsyncThunk('auth/login-user', async (data, thunkApi) => {
  try {
    const { payload, navigate } = data;

    const response = await authApi.loginUser(payload);

    navigate(ROUTE.PERSONAL_ACCOUNT);
    thunkApi.dispatch(getProfile());

    return response;
  } catch (error) {
    const { response } = error;

    thunkApi.dispatch(setAuthErrors(normalizeErrorResponse(response?.data?.errors)));

    if (response?.data?.message) {
      toast(response?.data?.message, { type: 'error', position: 'top-right' });
    }
  }
});

export const recoveryPassword = createAsyncThunk(
  'auth/recovery-password',
  async (data, thunkApi) => {
    try {
      const { payload, navigate } = data;

      const response = await authApi.recoveryPassword(payload);

      navigate(ROUTE.AUTH.FORGOT_PASSWORD_REQUESTED);

      toast(response?.message, { type: 'success', position: 'top-right' });

      return response?.message;
    } catch (error) {
      const { response } = error;

      thunkApi.dispatch(setAuthErrors(normalizeErrorResponse(response?.data?.errors)));
    }
  },
);

export const validatePasswordToken = createAsyncThunk(
  'auth/validate-password-token',
  async (data) => {
    try {
      const { payload } = data;

      const response = await authApi.confirmEmail(payload?.id);

      return response;
    } catch (error) {
      const { navigate } = data;

      navigate(ROUTE.AUTH.FORGOT_PASSWORD);
    }
  },
);

export const resetPassword = createAsyncThunk('auth/reset-password', async (data, thunkApi) => {
  try {
    const { id, payload, navigate } = data;

    const response = await authApi.updatePassword(id, payload);

    navigate(ROUTE.AUTH.FORGOT_PASSWORD_SUCCESS);

    toast(response?.message, { type: 'success', position: 'top-right' });

    return response?.message;
  } catch (error) {
    const { response } = error;

    thunkApi.dispatch(setAuthErrors(normalizeErrorResponse(response?.data?.errors)));
  }
});

export const logoutUser = createAsyncThunk('auth/logout-user', async (data, thunkApi) => {
  try {
    const { navigate } = data;

    const response = await authApi.logout();

    thunkApi.dispatch(clearProfileState());
    localStorage.removeItem('profile');

    navigate(ROUTE.AUTH.SIGN_IN);

    return response;
  } catch (error) {
    console.error(error);
  }
});
